import { Title } from "@mantine/core";

export function HeaderLeft() {
  return <Title>Devices</Title>;
}
